export class Application {

	constructor() {

		this.videos = 0
	}

	videos: number;
	notification: Notification;
}

export class Notification {

	enabled: boolean;
	message: string;
}